import { getShouldShowCaptionsForStudent } from '../../store/selectors/sharedSelectors'
import { MultiWayToggle } from '../MultiWayToggle'
import React from 'react'

import { useSelector } from 'react-redux'

/**
 * CaptionSelector - a input for determining if a student is allowed to see captions
 *
 * @param {Object} props - the react props
 * @param {string} props.studentId - the id of the student this form is for
 * @param {(showCaptions: boolean) => any} props.onSelect - a callback for when the user selects a new option
 * @param {string} props.className? - the class name to apply to the component
 *
 * @return {React$Node}
 */
export function CaptionSelector({
	studentId,
	className,
	onSelect,
}: {
	studentId: string,
	onSelect: (showCaptions: boolean) => any,
	className?: string,
}): React$Node {
	const currentCaptionSelection = useSelector(state =>
		getShouldShowCaptionsForStudent(state, studentId)
	)

	return (
		<MultiWayToggle
			options={[
				{
					value: false,
					label: 'hide',
					ariaLabel: 'hide captions',
				},
				{
					value: true,
					label: 'show',
					ariaLabel: 'show captions',
				},
			]}
			onSelectOption={onSelect}
			selectedOption={currentCaptionSelection}
			className={className}
		/>
	)
}
